<!-- 试用报告弹窗 -->
<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      width="564px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="trail_content">
        <div class="trail_main">
          <div class="closeImg" @click="handleClose"></div>
          <div class="main">
            <div class="trail_title">试用反馈</div>
            <div class="trail_tip">请在收到试用品后认真填写以下试用报告！</div>
            <div class="questions">
              <div v-for="(item, index) in questions" :key="index">
                <!-- 单选 -->
                <div class="question_item check" v-if="item.type === 1">
                  <div class="q_title">
                    <span
                      ><span class="q_start" v-if="item.isMust">*</span
                      >{{
                        index < 9 ? "0" + Number(index + 1) : Number(index + 1)
                      }}</span
                    >
                    <span class="q_type">[单选]</span>
                    {{ item.title }}
                  </div>
                  <div
                    class="q_option"
                    v-for="item2 in item.options"
                    :key="item2.optionId"
                  >
                    <div
                      :class="{ q_checkBox: true, act: item2.isSelect }"
                    ></div>
                    <div class="q_text">{{ item2.description }}</div>
                  </div>
                </div>

                <!-- 多选 -->
                <div class="question_item check" v-if="item.type === 2">
                  <div class="q_title">
                    <span
                      ><span class="q_start" v-if="item.isMust">*</span
                      >{{
                        index < 9 ? "0" + Number(index + 1) : Number(index + 1)
                      }}</span
                    >
                    <span class="q_type">[多选]</span>
                    {{ item.title }}
                  </div>
                  <div
                    class="q_option"
                    v-for="item2 in item.options"
                    :key="item2.optionId"
                  >
                    <div
                      :class="{ q_checkBox: true, act: item2.isSelect }"
                    ></div>
                    <div class="q_text">{{ item2.description }}</div>
                  </div>
                </div>

                <!-- 填空 -->
                <div class="question_item" v-if="item.type === 3">
                  <div class="q_title">
                    <span
                      ><span class="q_start" v-if="item.isMust">*</span
                      >{{
                        index < 9 ? "0" + Number(index + 1) : Number(index + 1)
                      }}</span
                    >
                    <span class="q_type">[填空]</span>
                    {{ item.title }}
                  </div>
                  <div class="q_fillText">
                    {{ item.submitOptionText }}
                  </div>
                </div>

                <!-- 图片单选 -->
                <div class="question_item" v-if="item.type === 4">
                  <div class="q_title">
                    <span
                      ><span class="q_start" v-if="item.isMust">*</span
                      >{{
                        index < 9 ? "0" + Number(index + 1) : Number(index + 1)
                      }}</span
                    >
                    <span class="q_type">[图片单选]</span>
                    {{ item.title }}
                  </div>
                  <div
                    class="q_option"
                    v-for="item2 in item.options"
                    :key="item2.optionId"
                  >
                    <div
                      :class="{ q_checkBox: true, act: item2.isSelect }"
                    ></div>
                    <div class="q_img">
                      <div
                        class="img-container"
                        @click="showIamgeHandler(item2.picUrl)"
                      >
                        <img :src="item2.picUrl" alt="" />
                        <div class="img-overlay">
                          <i class="el-icon-zoom-in"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 图片上传 -->
                <div class="question_item" v-if="item.type === 6">
                  <div class="q_title">
                    <span
                      ><span class="q_start" v-if="item.isMust">*</span
                      >{{
                        index < 9 ? "0" + Number(index + 1) : Number(index + 1)
                      }}</span
                    >
                    <span class="q_type">[图片上传]</span>
                    {{ item.title }}
                  </div>
                  <div class="q_option">
                    <div class="q_upImg">
                      <div
                        class="img-container"
                        v-for="(imgitem, idx) in item.submitPicUrls"
                        :key="idx"
                        @click="showIamgeHandler(imgitem)"
                      >
                        <img :src="imgitem" alt="" />
                        <div class="img-overlay">
                          <i class="el-icon-zoom-in"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="submitTime">提交时间：{{ submitTime }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <show-image
      :visible.sync="showImageDialog"
      :image-url="currentImageUrl"
    ></show-image>
  </div>
</template>

<script>
import {
  getTialReportOptions,
  getTialReportAnswer
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import showImage from "./showImage.vue";
export default {
  name: "CustomDialog",
  props: {
    // 控制弹窗显示/隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    currenttrailReport: {},
  },
  components: {
    showImage,
  },
  data() {
    return {
      questions: [],
      recordId: "",
      activityId: "",
      openId: "",
      submitTime: "",
      showImageDialog: false,
      currentImageUrl: "",
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.getTialReport();
      }
    },
  },
  methods: {
    getTialReport() {
      let allQuestions = [];
      getTialReportOptions(this.currenttrailReport.activityId).then((res) => {
        //获取题目
        if (res.code == 1) {
          allQuestions = res.data;
        }
        getTialReportAnswer({
          // 获取答案
          recordId: this.currenttrailReport.id,
          activityId: this.currenttrailReport.activityId,
          venderId: this.currenttrailReport.venderId,
          pin: this.currenttrailReport.pin,
        }).then((res) => {
          if (res.code == 1) {
            let answer = res.data;
            this.submitTime = answer[0].submitTime;
            this.questions = allQuestions.map((question) => {
              const matchedAnswer = answer.find(
                (a) => a.questionId === question.questionId
              );
              console.log(matchedAnswer,'21221');
              if (!matchedAnswer) return question;

              // 处理选择题（单选/多选/图片单选）
              if ([1, 2, 4].includes(question.type)) {
                return {
                  ...question,
                  options: question.options.map((option) => ({
                    ...option,
                    isSelect:
                      matchedAnswer.optionIds&&matchedAnswer.optionIds.includes(Number(option.optionId)) ||
                      false,
                  })),
                };
              }
              // 处理填空题
              if (question.type === 3) {
                return {
                  ...question,
                  submitOptionText: matchedAnswer.submitInputText,
                };
              }
              // 处理图片上传题
              if (question.type === 6) {
                return {
                  ...question,
                  submitPicUrls: matchedAnswer.submitPicUrls,
                };
              }
              return question;
            });
          }
        });
      });
    },
    showIamgeHandler(url) {
      this.currentImageUrl = url;
      this.showImageDialog = true;
    },
    // 关闭弹窗
    handleClose() {
      this.$emit("update:visible", false); // 更新父组件的 visible 状态
      this.$emit("close"); // 触发关闭事件
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

:deep(.el-dialog) {
  background: transparent !important;
  box-shadow: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

:deep(.el-dialog__header) {
  display: none;
}

:deep(.el-dialog__body) {
  padding: 0px !important;
  background-color: transparent !important;
}

.trail_content {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .trail_main {
    padding: 12px;
    background-color: #fff;
    border-radius: 24px;
    width: 388px;

    .closeImg {
      width: 46px;
      height: 46px;
      background-color: #343435;
      border-radius: 50%;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 99999;
      background-image: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/close_dialog.svg");
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
    }

    .main {
      width: 364px;
      color: #333333;
      display: flex;
      flex-direction: column;
      background-color: #f8f8f8;
      overflow-y: auto;
      max-height: 800px;
      // border-radius: 20px;

      .trail_title {
        padding: 114px 0 10px 22px;
        font-size: 22px;
        background-image: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/trail_bg.svg");
        background-repeat: no-repeat;
      }

      .trail_tip {
        font-size: 14px;
        color: #999999;
        margin-left: 22px;
      }

      .questions {
        width: 100%;
        padding: 15px 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .question_item {
          background-color: #fff;
          padding: 22px 10px;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          gap: 10px;

          .q_title {
            width: 100%;
            // display: flex;
            // align-items: center;
            font-size: 14px;
            // white-space: nowrap;

            .q_start {
              color: #fb0d0d;
            }

            .q_type {
              color: #578bff;
              margin: 0 4px;
              white-space: nowrap;
            }
          }

          .q_fillText {
            width: 100%;
            height: 130px;
            background: #f4f4f4;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid #dfdfdf;
            padding: 10px;
            font-size: 12px;
            line-height: 16px;
          }

          .q_option {
            width: 100%;
            display: flex;
            align-items: center;

            .q_checkBox {
              width: 14px;
              height: 14px;
              background: #ededed;
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #d5d5d5;
              margin-right: 5px;

              &.act {
                background-image: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/selectquestion.svg");
                background-size: cover;
                background-color: transparent;
                position: relative;

                &::after {
                  content: "";
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  background-color: #ededed; // 修改颜色值
                  mask-image: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/selectquestion.svg");
                  mask-size: cover;
                  -webkit-mask-image: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/selectquestion.svg");
                  -webkit-mask-size: cover;
                }
              }
            }

            .q_text {
              font-size: 12px;
              line-height: 12px;
            }

            .q_img {
              width: 48px;
              height: 48px;
              border-radius: 4px;

              .img-container {
                position: relative;
                width: 100%;
                height: 100%;
                cursor: pointer;

                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 4px;
                }

                .img-overlay {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  background-color: rgba(0, 0, 0, 0.5);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  opacity: 0;
                  transition: opacity 0.3s;
                  border-radius: 4px;

                  i {
                    color: #fff;
                    font-size: 20px;
                  }
                }

                &:hover .img-overlay {
                  opacity: 1;
                }
              }
            }

            .q_upImg {
              display: flex;
              flex-wrap: wrap;
              gap: 14px;

              .img-container {
                position: relative;
                width: 93px;
                height: 93px;
                cursor: pointer;

                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 4px;
                }

                .img-overlay {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  background-color: rgba(0, 0, 0, 0.5);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  opacity: 0;
                  transition: opacity 0.3s;
                  border-radius: 4px;

                  i {
                    color: #fff;
                    font-size: 24px;
                  }
                }

                &:hover .img-overlay {
                  opacity: 1;
                }
              }
            }
          }
        }

        .check {
          gap: 18px;
        }
      }

      .submitTime {
        width: 100%;
        font-size: 14px;
        text-align: center;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
